













































import {
    Component,
    Vue,
    Prop
} from "vue-property-decorator";
import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    pageDataType
} from "../types";
import {
    HOST
} from "../global";
import {
    swiper,
    swiperSlide
} from "vue-awesome-swiper";
import {
    TweenMax,
    TimelineLite,
    Power3,
    Power4,
    Power1,
    Power2,
    TimelineMax,
} from "gsap";
import ScrollMagic from "scrollmagic";
import gsap from "scrollmagic";

@Component({
    name: "NewssliderCard",
    components: {
        swiper,
        swiperSlide,
    },
})
export default class NewssliderCard extends Vue {
    @Prop() readonly compData!: any;
    public HOST: string = HOST;
    public swiperOption: any = {
        slidesPerView: 4,
        spaceBetween: 30,
        mousewheel: false,
        pagination: false,
        fadeEffect: {
            crossFade: true,
        },
        navigation: {
            nextEl: "#swiper-button-next",
            prevEl: "#swiper-button-prev",
        },
        breakpoints: {
            767: {
                slidesPerView: 1,
                spaceBetween: 30,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            1025: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1280: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1905: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
        },
    };
    public newsSlider() {
        const nwtimeline = new TimelineMax()
            .staggerFrom(
                ".sq-h-news-header",
                0.6, {
                    yPercent: 20,
                    autoAlpha: 0,
                    ease: Power2.easeOut,
                    clearProps: "all",
                },
                0.05
            )
            .from(
                ".news-slider-nav",
                0.5, {
                    xPercent: 20,
                    autoAlpha: 0,
                    ease: Power2.easeOut,
                    clearProps: "all",
                },
                "-=.1"
            )
            .from(
                ".sq-h-slider-area",
                0.5, {
                    yPercent: 20,
                    autoAlpha: 0,
                    ease: Power2.easeInOut,
                    clearProps: "all",
                },
                "-=.1"
            );

        const controller = new ScrollMagic.Controller();
        const scene = new ScrollMagic.Scene({
                triggerElement: ".newsslider-wrap",
                reverse: false,
            })
            .setTween(nwtimeline)
            .addTo(controller);
    }
    public mounted() {
        this.newsSlider();
    }
}
